import Message from "../../message";
import {useMainStore} from "@/store";

export default class NewLeader extends Message
{
    handle()
    {
        useMainStore().SET_GUILD_LEADER(this.message.user_id);
    }
}
